import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/w2gkAJEDEn3RhUWzJ11HSj/ChatGPT_Image_19_may_2026,_13_47_31.png',
  caption: 'Velas saladas — Mantequilla con hierbas y frutas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/d7nycvhPpUZgEeTuqY9czB/Elegant_gourmet_edible_candle_dessert_202605191346.jpg',
  caption: 'Mesa elegante — Vela artesanal con frutos y flores'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/g8Ty6cVN6SJr9hmoLFHpbF/Gourmet_edible_candles_arranged_on_202605191345.jpg',
  caption: 'Trío gourmet — Tiramisú, chocolate y vainilla'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nVaoVruN5uXDQ6UdS9Vpbg/Aesthetic_gourmet_edible_matcha_candle_202605191343.jpg',
  caption: 'Estética matcha — Vela dessert estilo café japonés'
}];
export function Gallery() {
  const [index, setIndex] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % IMAGES.length);
    }, 4000);
    return () => clearInterval(id);
  }, []);
  return <section className="py-12 md:py-16 px-4 md:px-6 bg-brand-ivory" data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        <div className="text-center mb-6 md:mb-8" data-id="element-98">
          <span className="inline-block text-brand-gold font-bold tracking-widest text-[10px] md:text-sm uppercase border border-brand-gold/30 px-3 py-1 rounded-full bg-brand-gold/10" data-id="element-99">
            🕯️ Inspiración Gourmet
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-brand-choco-deep mt-3 md:mt-4" data-id="element-100">
            Lo que vas a poder crear
          </h2>
        </div>

        <div className="relative aspect-[4/3] md:aspect-[16/9] rounded-2xl overflow-hidden shadow-2xl border border-brand-choco/10 bg-brand-choco-deep" data-id="element-101">
          <AnimatePresence mode="wait" data-id="element-102">
            <motion.div key={index} initial={{
            opacity: 0,
            scale: 1.05
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.98
          }} transition={{
            duration: 0.8,
            ease: 'easeInOut'
          }} className="absolute inset-0" data-id="element-103">
              <img src={IMAGES[index].src} alt={IMAGES[index].caption} className="w-full h-full object-cover" data-id="element-104" />
              {/* Caption gradient overlay */}
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-6 bg-gradient-to-t from-black/70 via-black/30 to-transparent" data-id="element-105">
                <p className="text-white font-serif italic text-sm md:text-lg text-center" data-id="element-106">
                  "{IMAGES[index].caption}"
                </p>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation arrows */}
          <button type="button" aria-label="Anterior" onClick={() => setIndex(prev => (prev - 1 + IMAGES.length) % IMAGES.length)} className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/80 hover:bg-white text-brand-choco-deep flex items-center justify-center shadow-md transition-colors z-10" data-id="element-107">
            ‹
          </button>
          <button type="button" aria-label="Siguiente" onClick={() => setIndex(prev => (prev + 1) % IMAGES.length)} className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/80 hover:bg-white text-brand-choco-deep flex items-center justify-center shadow-md transition-colors z-10" data-id="element-108">
            ›
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-4 md:mt-5" data-id="element-109">
          {IMAGES.map((_, i) => <button key={i} type="button" aria-label={`Ir a imagen ${i + 1}`} onClick={() => setIndex(i)} className={`h-2 rounded-full transition-all ${i === index ? 'w-8 bg-brand-gold' : 'w-2 bg-brand-choco/30 hover:bg-brand-choco/50'}`} data-id="element-110" />)}
        </div>
      </div>
    </section>;
}